const impressum_de = `
## Impressum  

**Esther Ratsch und Jörg Schultz GbR**  
Am Mühlschutz 2  
97348 Rödelsee  

---

### Kontakt  
E-Mail: [Joerg.Schultz@tier-wohl-team.de](mailto:Joerg.Schultz@tier-wohl-team.de)  

---

### USt-IdNr.  
DE348741712  

---

### Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV  
Jörg Schultz  

---

### Design  
Jörg Schultz  

`;

const impressum_en = `
    ## Imprint  

**Esther Ratsch and Jörg Schultz GbR**  
Am Mühlschutz 2  
97348 Rödelsee  
Germany  

---

### Contact  
Email: [Joerg.Schultz@tier-wohl-team.de](mailto:Joerg.Schultz@tier-wohl-team.de)  

---

### VAT Identification Number  
DE348741712  

---

### Responsible for Content According to § 55 Abs. 2 RStV  
Jörg Schultz  

---

### Design  
Jörg Schultz  
    `;
export const Impressum = {"de": impressum_de, "en": impressum_en};